import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({total, subTotal, subTotalVat}) => {
  return (
    <div className="Totals">
      <div className="section">
        <div className="header">Subtotal</div>
        <div className="value">
          <Money amount={subTotal} />
        </div>
      </div>
      <div className="section">
        <div className="header">VAT</div>
        <div className="value">{subTotalVat}</div>
      </div>
      <div className="section">
        <div className="header">Total</div>
        <div className="value">
          <Money amount={total} />
        </div>
      </div>
    </div>
  );
};

export default Totals;
